<template>
    <div class="notify-list">
        <component
            v-for="(noty, index) in $store.state.notifyApp.notifies"
            :key="index"
            :is="noty.component"
            :text="noty.text"
            @close="$store.dispatch('removeNotify', index)"
        />
    </div>
</template>
<script>
import NotificationApp from './NotificationApp.vue';
import MobileAdvisePopup from '@/components/UI/banners/MobileAdvisePopup.vue';

export default {
    name: 'NotificationsApp',
    components: {
        NotificationApp,
        MobileAdvisePopup,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';

.notify-list {
    position: fixed;
    top: rem(115);
    right: rem(140);
    z-index: 500;

    @include on-mobile {
        right: mrem(0);
        top: mrem(56);
    }
}
</style>
